import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private route: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const authSession = localStorage.getItem('_');
    if (authSession == null || authSession == undefined) {
      this.route.navigate(['/login'], { queryParams: next.queryParams, queryParamsHandling: 'merge' });
      return false;
    }
    try {
      var obj = JSON.parse(atob(authSession));
      if (obj.status == 1) {
        return true;
      } else {
        this.route.navigate(['/login'], { queryParams: next.queryParams, queryParamsHandling: 'merge' });
        return false;
      }
    } catch (error) {
      this.route.navigate(['/login'], { queryParams: next.queryParams, queryParamsHandling: 'merge' });
      return false;
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
